/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tag-ids.vue?vue&type=template&id=738c9755&scoped=true&"
import script from "./tag-ids.vue?vue&type=script&lang=js&"
export * from "./tag-ids.vue?vue&type=script&lang=js&"
import style0 from "./tag-ids.vue?vue&type=style&index=0&id=738c9755&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c9755",
  null
  
)

export default component.exports